import * as React from 'react';

import t from './locales';
import { returnTicketTotalAmount } from './helpers';
import { ICurrency, IJEPTicketOrderItem } from './types';
import InventoryCartItemView from './InventoryCartItemView';
import Price from '../Shared/Price';

interface IProps {
  items: Array<IJEPTicketOrderItem>;
  currentExchangeRate?: number;
  localCurrency?: ICurrency;
}

const TWPInventoryTicketOrderItemList: React.FC<IProps> = (props) => {
  return (
    <React.Fragment>
      {props.items && props.items.map((item, index) => {
        const plan = item.ticket.plans.find(p => p.planId === item.planId)
        const itemPrice = returnTicketTotalAmount(plan.adultSellingPrice, item.adults.length) + returnTicketTotalAmount(plan.childSellingPrice, item.children.length)
        return (
          <InventoryCartItemView key={`inventory-ticket-order-item-${index}`}>
            <div>
              <p>{item.ticket.name}</p>
              <span className="mute">
                {item.adults && <span>{t.adultNum()} {item.adults.length}</span>}
                {item.children && <span>{t.childNum()} {item.children.length}</span>}
              </span>
            </div>
            <Price
              price={itemPrice}
              fullPrice={itemPrice}
              fontSize={12}
              localCurrency={props.localCurrency}/>
          </InventoryCartItemView>
        )
      })}
    </React.Fragment>
  );
}

export default TWPInventoryTicketOrderItemList;
